import "./App.css";
import { AppRouter } from "./router";
import { useIsDbAwake } from "./useIsDbAwake";
import { ThemeProvider } from "@mui/material";
import { WakingUpAnimation } from "./UI/WakingUpAnimation";
import { theme } from "./theme";
import { ErrorWindow } from "components/ErrorWindow";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { DevIndicator } from "components/DevIndicator";
import { useState, createContext, useEffect } from "react";

export const GlobalState = createContext();

function App() {
  const { isDbAwake, error, setError } = useIsDbAwake();
  const [authBackUrl, setAuthBackUrl] = useState("/");

  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("refstr-dev.com")) {
      const newUrl = currentUrl.replace(
        "www.refstr-dev.com",
        "button-dev.referral-stream.com"
      );
      window.location.href = newUrl;
      return;
    }

    if (currentUrl.includes("refstr.com")) {
      const newUrl = currentUrl.replace(
        "www.refstr.com",
        "button.referral-stream.com"
      );
      window.location.href = newUrl;
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalState.Provider value={{ authBackUrl, setAuthBackUrl }}>
        <DevIndicator />
        <div className="App">
          {isDbAwake ? <AppRouter /> : <WakingUpAnimation />}
          <ToastContainer />
        </div>
        {error && (
          <ErrorWindow error={error} handleClose={() => setError("")} />
        )}
      </GlobalState.Provider>
    </ThemeProvider>
  );
}

export default App;
